import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';

const FundedDuplicate = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <p>Unfortunately, we are unable to approve your request for credit due to having an existing loan funded in the last 60 days. You are welcome to resubmit a credit application with us after 60 days from the funding date of your existing loan.</p>
      </div>
    </div>
  );
};

FundedDuplicate.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(FundedDuplicate);
